export default __webpack_public_path__ + "static/media/3.02272dc1.png";